import { Scale } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"

/** Raleway, a tall wall calendar: the year at the foot of its picture; a month's name over its days down a list, the contact under. */
export const Raleway: CalendarDesign = {
  cover: PictureCover({ align: HorizontalAlign.LEFT, at: 0.02, size: 0.22 }),
  page: ({ body, contact, gap, language, short, year }, month) => {
    const [title, list] = Slice.top(body, Scale(short, 0.08), gap)
    return [
      Area.title(title, month, language),
      ...Area.columns(list, month, year, 1, gap),
      Area.footer(contact),
    ]
  },
  pages: "month",
}
